import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useEffect } from 'react'
import Select from 'react-select'
import makeAnimated from 'react-select/animated'
const EmployeeTypeSelect = ({ setSelectedType, isMulti }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [isLoading, setLoading] = useState(true)

  const data = [
    {
      id: 4,
      label: t('hooks.employeeTypeSelect.report'),

      value: 4,
    },
    {
      id: 1,
      label: t('hooks.employeeTypeSelect.statement'),
      value: 1,
    },
  ]

  const animatedComponents = makeAnimated()
  const handleSelect = (dataEmployees) => {
    isMulti
      ? setSelectedType(dataEmployees.map((employee) => employee.label))
      : setSelectedType(dataEmployees.label)
  }
  useEffect(() => {
    if (data[0]?.length !== 0) {
      setLoading(false)
    }
  }, [data])
  const selectInfoStyles = {
    width: '100%', 
    zIndex: 9996, 
    maxWidth: '100vh', 
    minWidth: '100vh', 
  };


  const mobileStyles = {
    maxWidth: '100%',
    minWidth: '100%', 
  };
  return (
    <div style={{ ...selectInfoStyles, ...mobileStyles}}>
      <Select
        closeMenuOnSelect={true}
        components={animatedComponents}
        options={data}
        onChange={handleSelect}
        isSearchable={true}
        placeholder={t('hooks.employeeTypeSelect.placeholder')}
        autosize={true}
        noOptionsMessage={() => t('hooks.common.noResults')}
        isMulti={isMulti ? true : false}
        isLoading={isLoading}
      />
    </div>
  )
}

export default EmployeeTypeSelect
